import { getCartDisplayCount } from './constant.js';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { translate, getLanguage, setLanguage } from 'react-switch-lang';
import { detectMarathiInUrl } from './utils/deepLink';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import NewHeader from './newHeader.js';
import Footer from './Footer.js';
import './assets/dist/css/bootstrap.css';
import './assets/css/style.css';
import './assets/fontawesome/css/all.min.css';
import './EventListingPage.css';
import * as myConstClass from './constant.js';
import { cartHasProducts, cartHasMagazines, cartHasRegularEvents, getCartConflictMessage } from './constant.js';
import { updateGuestCartDisplay, getGuestCartConflictMessage } from './utils/guestCartHelpers';
import { convertFromRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import $ from 'jquery';
import thumbImage from './assets/images/thumb.png';
import MachineTests from './assets/images/MachineTests.jpg';
import MachineTests_mr from './assets/images/Machine_Tests_m_mr.jpg';
import en from './en.json';
import ma from './ma.json';

// Import reusable components
import EventListingHero from './components/eventListing/EventListingHero';
import EventFilters from './components/eventListing/EventFilters';
import EventListGrid from './components/eventListing/EventListGrid';
import EventCardNew from './components/eventListing/EventCardNew';
import MachineTestCard from './components/MachineTestCard.jsx';
import SelectedCategoryInfo from './components/eventListing/SelectedCategoryInfo';

class EventListingPage extends Component {
    constructor(props) {
        super(props);
        // Derive initial category from route params to avoid flash of default filter
        const { categoryName: paramCategoryName, categoryId: paramCategoryId } = props.match.params || {};
        const decodedCategoryName = decodeURIComponent(paramCategoryName || '');
        const initialEventFilter = decodedCategoryName ? [decodedCategoryName] : ['Residential Study Courses'];
        this.state = {
            categoryName: decodedCategoryName,
            categoryId: paramCategoryId || '',
            events: [],
            filteredEvents: [],
            allLoadedEvents: [], // Store all loaded events
            machineTests: [], // Store machine tests separately
            allLoadedMachineTests: [], // Store all loaded machine tests
            displayedEventsCount: 10, // Number of events to display initially
            displayedTestsCount: 6, // Number of machine tests to display initially (2 rows of 3)
            loading: false,
            loadingMore: false, // Loading state for lazy loading
            hasMoreEvents: true, // Whether there are more events to load
            currentLanguage: localStorage.getItem('key') || getLanguage() || 'en', // Track current display language for re-rendering on toggle
            filters: {
                events: initialEventFilter, // Default selected event (derived from route if present)
                topics: ['All'],
                language: 'All',
                subTopics: ['All'],
                hasSchedule: undefined
            },
            pagination: {
                page: 1,
                pageSize: 20,
                totalCount: 0,
                totalPages: 0,
                hasNextPage: false,
                hasPreviousPage: false
            },
            filterOptions: {
                eventTypes: [],
                topics: [],
                ageGroups: []
            },
            eventTypeDescriptions: {}, // Store event type descriptions from API
            // Modal state for appointment alert
            tempCartData: null // Temporarily store data while modal is open
        };
        
        // Ref for scroll detection
        this.scrollContainerRef = React.createRef();
        this.loadMoreObserver = null;
        
        // Bind modal methods
        this.addToCartContinue = this.addToCartContinue.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        
        // Initialize language from localStorage (user's explicit choice via toggle)
        // This takes priority over URL-based detection
        const storedLanguage = localStorage.getItem('key');
        if (storedLanguage) {
            setLanguage(storedLanguage);
        } else {
            // Fallback: Auto-detect language from URL content only if no explicit choice exists
            try {
                const currentUrl = window.location.href;
                const currentLanguage = getLanguage();
                const hasMarathi = detectMarathiInUrl(currentUrl);
                
                // If URL contains Marathi characters, switch to Marathi
                if (hasMarathi && currentLanguage !== 'ma') {
                    setLanguage('ma');
                    localStorage.setItem('key', 'ma');
                }
                // If URL is in English (no Marathi characters), switch to English
                else if (!hasMarathi && currentLanguage !== 'en') {
                    setLanguage('en');
                    localStorage.setItem('key', 'en');
                }
            } catch (e) {
                console.error('Failed to detect language from URL', e);
            }
        }   
        
        // Get category name and ID from URL parameters
        const { categoryName, categoryId } = this.props.match.params;
        const decodedCategoryName = decodeURIComponent(categoryName || '');
        
        // Check URL search params for shared filters (from share functionality)
        const searchParams = new URLSearchParams(window.location.search);
        
        // Support both old (name-based) and new (ID-based) URL parameters for backward compatibility
        const sharedEventType = searchParams.get('eventType'); // Old format (name)
        const sharedEventTypeId = searchParams.get('event_type_id'); // New format (ID)
        
        // Topics - support both old (names) and new (IDs)
        const sharedTopicsAll = searchParams.getAll('topics'); // Old format
        const sharedTopicsRaw = (sharedTopicsAll && sharedTopicsAll.length > 0) ? sharedTopicsAll : (searchParams.get('topics') ? [searchParams.get('topics')] : []);
        const sharedTopics = sharedTopicsRaw.length > 1 ? sharedTopicsRaw : (sharedTopicsRaw[0] || null);
        const sharedTopicId = searchParams.get('topic_id'); // New format (comma-separated IDs)
        
        const sharedLanguage = searchParams.get('language');
        // Support new format: language_id (numeric)
        const sharedLanguageId = searchParams.get('language_id');
        
        // Subtopics - support both old (names) and new (IDs)
        const sharedSubTopicsAll = searchParams.getAll('subTopics'); // Old format
        const sharedSubTopicsRaw = (sharedSubTopicsAll && sharedSubTopicsAll.length > 0) ? sharedSubTopicsAll : (searchParams.get('subTopics') ? [searchParams.get('subTopics')] : []);
        const sharedSubTopics = sharedSubTopicsRaw.length > 1 ? sharedSubTopicsRaw : (sharedSubTopicsRaw[0] || null);
        
        // New ID-based format (replaces old subtopicIds which was an internal param)
        const sharedSubtopicId = searchParams.get('subtopic_id'); // New format (comma-separated IDs)
        const sharedSubtopicIdsAll = searchParams.getAll('subtopicIds'); // Old internal format
        const sharedSubtopicIdsRaw = (sharedSubtopicIdsAll && sharedSubtopicIdsAll.length > 0) ? sharedSubtopicIdsAll : (searchParams.get('subtopicIds') ? [searchParams.get('subtopicIds')] : []);
        const sharedSubtopicIds = sharedSubtopicIdsRaw.length > 1 ? sharedSubtopicIdsRaw : (sharedSubtopicIdsRaw[0] || null);
        // Check if filters were passed via location state (from back navigation or navbar navigation)
        const locationState = this.props.location.state || {};
        
        // Store raw ID parameters to resolve after filterOptions are loaded
        this.pendingIdResolve = {
            eventTypeId: sharedEventTypeId,
            topicIds: sharedTopicId ? sharedTopicId.split(',').map(id => parseInt(id.trim(), 10)).filter(id => !isNaN(id)) : [],
            subtopicIds: sharedSubtopicId ? sharedSubtopicId.split(',').map(id => parseInt(id.trim(), 10)).filter(id => !isNaN(id)) : []
        };
        
        // Priority: URL params (shared link) > location state > defaults
        // Handle topics - can be an array (from back navigation) or single value (from navbar)
        let topicsFilter = ['All'];
        if (sharedTopics) {
            // If sharedTopics is an array (repeated params), use it directly; otherwise split comma-separated string
            if (Array.isArray(sharedTopics)) {
                topicsFilter = sharedTopics.map(t => String(t).trim());
            } else {
                topicsFilter = String(sharedTopics).split(',').map(t => t.trim()).filter(Boolean);
            }
        } else if (locationState.topics && Array.isArray(locationState.topics)) {
            // Full topics array passed (from back navigation)
            topicsFilter = locationState.topics;
        } else if (locationState.selectedTopic) {
            // Single topic passed (from navbar navigation)
            topicsFilter = [locationState.selectedTopic];
        }
        // Note: If sharedTopicId is present, topics will be resolved after filterOptions are loaded
        
        // Handle subtopics - can be an array or single value
        let subTopicsFilter = ['All'];
        if (sharedSubTopics) {
            if (Array.isArray(sharedSubTopics)) {
                subTopicsFilter = sharedSubTopics.map(st => String(st).trim());
            } else {
                subTopicsFilter = String(sharedSubTopics).split(',').map(st => st.trim()).filter(Boolean);
            }
        } else if (locationState.subTopics && Array.isArray(locationState.subTopics)) {
            subTopicsFilter = locationState.subTopics;
        } else if (locationState.selectedSubtopic) {
            subTopicsFilter = [locationState.selectedSubtopic];
        }
        // Note: If sharedSubtopicId is present, subtopics will be resolved after filterOptions are loaded
        
        // Handle subtopic IDs (internal tracking)
        let subtopicIds = [];
        if (sharedSubtopicId) {
            // New format: ?subtopic_id=1,2,3
            subtopicIds = sharedSubtopicId.split(',').map(id => parseInt(id.trim(), 10)).filter(id => !isNaN(id));
        } else if (sharedSubtopicIds) {
            // Old internal format: ?subtopicIds=1,2,3
            if (Array.isArray(sharedSubtopicIds)) {
                subtopicIds = sharedSubtopicIds.map(v => String(v).split(',')).flat().map(id => parseInt(id.trim(), 10)).filter(id => !isNaN(id));
            } else {
                subtopicIds = String(sharedSubtopicIds).split(',').map(id => parseInt(id.trim(), 10)).filter(id => !isNaN(id));
            }
        } else if (locationState.subtopicIds) {
            subtopicIds = locationState.subtopicIds;
        } else if (locationState.subtopicId) {
            subtopicIds = [locationState.subtopicId];
        }
        
        // Handle language
        let languageFilter = 'All';
        if (sharedLanguageId) {
            // Map numeric language_id to language name
            if (sharedLanguageId === '1') languageFilter = 'English';
            else if (sharedLanguageId === '2') languageFilter = 'Marathi';
            else if (sharedLanguageId === '3') languageFilter = 'Hindi';
            else languageFilter = 'All';
        } else if (sharedLanguage) {
            languageFilter = sharedLanguage;
        } else if (locationState.language) {
            languageFilter = locationState.language;
        }
        
        // Handle event type (category)
        let eventTypeFilter = decodedCategoryName;
        if (sharedEventType) {
            // Old format: name-based
            eventTypeFilter = sharedEventType;
        } else if (sharedEventTypeId) {
            // New format: ID-based (will be resolved to name after filterOptions loaded)
            // Don't set a default - wait for resolution
            eventTypeFilter = null;
        }
        
        // IMPORTANT: If we have a pending event type ID to resolve, don't set a default event type yet
        // Let the resolution happen first, then update filters with the resolved name
        const shouldWaitForResolution = this.pendingIdResolve && this.pendingIdResolve.eventTypeId;
        
        // Update filters with the category from URL and filters from location state or URL params
        const initialFilters = {
            events: shouldWaitForResolution ? [] : (eventTypeFilter ? [eventTypeFilter] : ['Residential Study Courses']),
            topics: topicsFilter,
            language: languageFilter,
            subTopics: subTopicsFilter,
            subtopicIds: subtopicIds,
            // Note: hasSchedule parameter removed from deep links as per requirement
            hasSchedule: (() => {
                // If navigation state has it, use it
                if (locationState.hasSchedule !== undefined) return locationState.hasSchedule;

                // Default behavior
                if (
                    eventTypeFilter &&
                    eventTypeFilter.toLowerCase().trim().includes('machine')
                ) {
                    return undefined; // show all
                }

                // All other event types → Active by default
                return true;
            })()
        };
        
        this.setState({
            categoryName: eventTypeFilter || decodedCategoryName,
            categoryId: categoryId || '',
            filters: initialFilters,
            currentLanguage: localStorage.getItem('key') || getLanguage() || 'en', // Set initial display language
            loading: true // show loader immediately while filter options and events are fetched
        });
        
        // Fetch filter options first, then events with the correct filter
        this.fetchFilterOptions().then((filterOptionsData) => {
            // Resolve IDs to names if present in URL
            let updatedFilters = { ...initialFilters };
            if (filterOptionsData && this.pendingIdResolve) {
                const resolved = this.resolveIdsToNames(filterOptionsData);
                
                if (resolved) {
                    // Update filters with resolved names from IDs
                    if (resolved.eventType) {
                        updatedFilters.events = [resolved.eventType];
                        this.setState({ categoryName: resolved.eventType });
                    }
                    if (resolved.topics && resolved.topics.length > 0) {
                        updatedFilters.topics = resolved.topics;
                    }
                    if (resolved.subtopicIds && resolved.subtopicIds.length > 0) {
                        updatedFilters.subtopicIds = resolved.subtopicIds;
                    }
                    
                    // Update state with resolved filters
                    this.setState({ filters: updatedFilters });
                }
                // Clear pending resolve
                this.pendingIdResolve = null;
            }
            
            // Check if the selected event is Machine Tests
            const isMachineTests = updatedFilters.events && updatedFilters.events[0] === 'Machine Tests';
            
            if (isMachineTests) {
                // Fetch machine tests
                this.fetchMachineTests(updatedFilters, this.state.pagination, true);
            } else {
                // After filter options are loaded, fetch events with the correct category filter
                this.fetchFilteredEvents(updatedFilters, this.state.pagination, true); // true = initial load
            }
            
            // Fetch event type description from API (matching old Events.js implementation)
            if (categoryId) {
                const language = getLanguage();
                this.fetchAndStoreEventTypeDescription(categoryId, language, decodedCategoryName);
            }
        });
    }
    
    componentWillUnmount() {
        // Clean up intersection observer
        if (this.loadMoreObserver) {
            this.loadMoreObserver.disconnect();
        }
    }
    
    // Setup intersection observer for lazy loading
    setupLazyLoadingObserver = () => {
        if (this.loadMoreObserver) {
            this.loadMoreObserver.disconnect();
        }
        
        // Create intersection observer to detect when user scrolls near bottom
        this.loadMoreObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.state.loadingMore) {
                        const { allLoadedEvents, allLoadedMachineTests, displayedEventsCount, displayedTestsCount, hasMoreEvents, filters } = this.state;
                        
                        // Check if viewing machine tests
                        const isMachineTests = filters.events && filters.events[0] === 'Machine Tests';
                        
                        if (isMachineTests) {
                            // For machine tests, check if there are more tests to display
                            const hasMoreToDisplay = allLoadedMachineTests.length > displayedTestsCount;
                            if (hasMoreToDisplay) {
                                this.loadMoreEvents();
                            }
                        } else {
                            // For regular events
                            const remainingInLoaded = allLoadedEvents.length - displayedEventsCount;
                            // Trigger if there are more events to fetch OR more events to display from loaded
                            if (hasMoreEvents || remainingInLoaded > 0) {
                                this.loadMoreEvents();
                            }
                        }
                    }
                });
            },
            {
                root: null,
                rootMargin: '200px', // Start loading 200px before reaching the bottom
                threshold: 0.1
            }
        );
        
        // Observe the load more trigger element
        const loadMoreTrigger = document.getElementById('load-more-trigger');
        if (loadMoreTrigger) {
            this.loadMoreObserver.observe(loadMoreTrigger);
        }
    }
    
    // Load more events (lazy loading)
    loadMoreEvents = async () => {
        const { allLoadedEvents, allLoadedMachineTests, displayedEventsCount, displayedTestsCount, filters, pagination, hasMoreEvents, loadingMore } = this.state;
        
        // Prevent multiple simultaneous loads
        if (loadingMore) return;
        
        // Check if we're viewing machine tests
        const isMachineTests = filters.events && filters.events[0] === 'Machine Tests';
        
        if (isMachineTests) {
            // Handle machine tests lazy loading (similar to regular events)
            const nextDisplayCount = displayedTestsCount + 6; // Load 6 more tests (2 rows)
            const remainingTests = allLoadedMachineTests.length - displayedTestsCount;
            
            // If we have tests already loaded that haven't been displayed yet, show them
            if (remainingTests > 0 && !hasMoreEvents) {
                // No more tests to fetch from API, but we have some loaded that aren't displayed yet
                this.setState(prevState => ({
                    displayedTestsCount: prevState.displayedTestsCount + 6,
                    loadingMore: false
                }), () => {
                    setTimeout(() => this.setupLazyLoadingObserver(), 100);
                });
                return;
            }
            
            // If we have enough tests already loaded, just increase the display count
            if (remainingTests >= 6) {
                this.setState(prevState => ({
                    displayedTestsCount: prevState.displayedTestsCount + 6,
                    loadingMore: false
                }), () => {
                    setTimeout(() => this.setupLazyLoadingObserver(), 100);
                });
                return;
            }
            
            // If we need more tests and there are more available, fetch from API
            if (hasMoreEvents && remainingTests < 6) {
                this.setState({ loadingMore: true });
                
                try {
                    // Calculate next page to fetch
                    const nextPage = pagination.page + 1;
                    const nextPagination = { ...pagination, page: nextPage };
                    
                    const params = this.buildApiParams(filters, nextPagination);
                    params.eventTypeIds = '3'; // Machine Tests
                    const queryString = new URLSearchParams(params).toString();
                    const apiUrl = `${myConstClass.NODE_API_BASE}/event/filter?${queryString}`;
                    
                    const response = await fetch(apiUrl);
                    const data = await response.json();
                    
                    if (data.status === 'true' && data.data && data.data.length > 0) {
                        // Transform new machine tests
                        const currentLanguage = getLanguage();
                        let transformedTests = await this.transformMachineTestsToCardFormat(data.data || [], currentLanguage);
                        
                        // Apply frontend language filter if specific language is selected (not 'All')
                        if (filters.language && filters.language !== 'All') {
                            const selectedLanguage = filters.language; // 'English', 'Marathi', or 'Hindi'
                            transformedTests = transformedTests.filter(test => {
                                const testLang = test.language || 'English';
                                return testLang === selectedLanguage;
                            });
                        }
                        
                        // Append to existing tests
                        const updatedAllTests = [...allLoadedMachineTests, ...transformedTests];
                        
                        // Check if there are more pages available
                        const stillHasMore = data.pagination?.hasNextPage === true;
                        
                        this.setState({
                            allLoadedMachineTests: updatedAllTests,
                            pagination: data.pagination || nextPagination,
                            hasMoreEvents: stillHasMore,
                            loadingMore: false
                        }, () => {
                            // Increase displayed count after new tests are loaded
                            this.setState(prevState => ({
                                displayedTestsCount: prevState.displayedTestsCount + 6
                            }), () => {
                                setTimeout(() => this.setupLazyLoadingObserver(), 100);
                            });
                        });
                    } else {
                        // No more tests available
                        this.setState({
                            hasMoreEvents: false,
                            loadingMore: false
                        });
                    }
                } catch (error) {
                    console.error('Error loading more machine tests:', error);
                    this.setState({ loadingMore: false });
                }
            } else if (!hasMoreEvents && remainingTests > 0) {
                // No more tests to load from API, but we have some to display
                this.setState(prevState => ({
                    displayedTestsCount: prevState.displayedTestsCount + 6
                }), () => {
                    setTimeout(() => this.setupLazyLoadingObserver(), 100);
                });
            }
            return;
        }
        
        // Handle regular events lazy loading
        const nextDisplayCount = displayedEventsCount + 10;
        const remainingInLoaded = allLoadedEvents.length - displayedEventsCount;
        
        // If we have events already loaded that haven't been displayed yet, show them
        if (remainingInLoaded > 0 && !hasMoreEvents) {
            // No more events to fetch from API, but we have some loaded that aren't displayed yet
            this.increaseDisplayedCount();
            return;
        }
        
        // If we have enough events already loaded, just increase the display count
        if (remainingInLoaded >= 10) {
            this.increaseDisplayedCount();
            return;
        }
        
        // If we need more events and there are more available, fetch from API
        if (hasMoreEvents && remainingInLoaded < 10) {
            this.setState({ loadingMore: true });
            
            try {
                // Calculate next page to fetch
                const nextPage = pagination.page + 1;
                const nextPagination = { ...pagination, page: nextPage };
                
                const params = this.buildApiParams(filters, nextPagination);
                const queryString = new URLSearchParams(params).toString();
                const apiUrl = `${myConstClass.NODE_API_BASE}/event/filter?${queryString}`;
                
                const response = await fetch(apiUrl);
                const data = await response.json();
                
                if (data.status === 'true' && data.data && data.data.length > 0) {
                    // Transform new events
                    let transformedEvents = this.transformApiEventsToCardFormat(data.data || []);
                    
                    // Apply frontend language filter if specific language is selected (not 'All')
                    if (filters.language && filters.language !== 'All') {
                        const selectedLanguage = filters.language; // 'English', 'Marathi', or 'Hindi'
                        transformedEvents = transformedEvents.filter(event => {
                            const eventLang = event.language || 'English';
                            return eventLang === selectedLanguage;
                        });
                    }
                    
                    // Append to existing events
                    const updatedAllEvents = [...allLoadedEvents, ...transformedEvents];
                    
                    // Check if there are more pages available - rely primarily on API response
                    const stillHasMore = data.pagination?.hasNextPage === true;
                    
                    // Also check if we've loaded all events based on totalCount
                    const totalCount = data.pagination?.totalCount || 0;
                    const loadedCount = updatedAllEvents.length;
                    const hasMoreByCount = totalCount > 0 && loadedCount < totalCount;
                    
                    
                    
                    // Use hasNextPage if available, otherwise fall back to count comparison
                    const finalHasMore = stillHasMore !== undefined ? stillHasMore : hasMoreByCount;
                    
                    this.setState({
                        allLoadedEvents: updatedAllEvents,
                        pagination: data.pagination || nextPagination,
                        hasMoreEvents: finalHasMore,
                        loadingMore: false
                    }, () => {
                        // Increase displayed count after new events are loaded
                        this.increaseDisplayedCount();
                    });
                } else {
                    // No more events available
                    
                    this.setState({
                        hasMoreEvents: false,
                        loadingMore: false
                    });
                }
            } catch (error) {
                console.error('Error loading more events:', error);
                this.setState({ loadingMore: false });
            }
        } else if (!hasMoreEvents) {
            // No more events to load, but we might still have some to display
            if (remainingInLoaded > 0) {
                this.increaseDisplayedCount();
            }
        }
    }
    
    // Increase the number of displayed events
    increaseDisplayedCount = () => {
        this.setState(prevState => ({
            displayedEventsCount: prevState.displayedEventsCount + 10
        }), () => {
            // Re-setup observer after state update
            setTimeout(() => this.setupLazyLoadingObserver(), 100);
        });
    }

    // Fetch event type description from Node API (uses /event/getEventType/:id)
    fetchEventTypeDescription = async (eventTypeId, language) => {
        if (!eventTypeId) return null;

        try {
            const lang = language === 'ma' ? 'ma' : 'en';
            const apiUrl = `${myConstClass.NODE_API_BASE}/event/getEventType/${eventTypeId}?language=${lang}`;

            const response = await fetch(apiUrl);
            if (!response.ok) return null;
            const data = await response.json();

            // Expected shape: { status: 'true', message: '...', data: { eventTypeId, eventType, description } }
            if (data && data.status === 'true' && data.data) {
                const d = Array.isArray(data.data) ? data.data[0] : data.data;
                return {
                    event_type: d.eventType || d.event_type || '',
                    event_description: d.description || d.descriptionEn || d.descriptionMr || '',
                    event_type_id: d.eventTypeId || eventTypeId
                };
            }

            return null;
        } catch (error) {
            return null;
        }
    }

    // Fetch and store event type description in state
    fetchAndStoreEventTypeDescription = async (eventTypeId, language, categoryName = null) => {
        const descriptionData = await this.fetchEventTypeDescription(eventTypeId, language);
        if (descriptionData) {
            this.setState(prevState => ({
                eventTypeDescriptions: {
                    ...prevState.eventTypeDescriptions,
                    [eventTypeId]: descriptionData
                }
            }));
        }
    }

    // Helper function to translate category name based on current language
    getTranslatedCategoryName = (categoryName) => {
        if (!categoryName) return categoryName;

        // Map category names to translation keys in ma.json/en.json
        const categoryToTranslationKey = {
            'Residential Study Courses': 'residentialsc',
            'One Day Workshops': '1day',
            '1-Day Workshops': '1day',
            '1-Day Workshop': '1day',
            'One Day Workshop': '1day',
            'Machine Tests': 'machine_tests',
            'Machine Test': 'machine_tests',
            'Rational Poojas': 'rational_poojas',
            'Rational Pooja': 'rational_poojas',
            'Free Events': 'free_events',
            'Free Event': 'free_events'
        };

        // Normalize category name for lookup
        const normalizedCategory = categoryName.trim();
        const translationKey = categoryToTranslationKey[normalizedCategory];

        if (!translationKey) {
            return categoryName;
        }

        // Use this.state.currentLanguage (reactive, correctly synced state)
        // rather than getLanguage() which can return stale/unsynced values during re-renders
        const langKey = this.state.currentLanguage === 'ma' ? 'ma' : 'en';
        
        // Access translation data directly from imported JSON files
        const translationData = langKey === 'ma' ? ma : en;
        const translatedValue = translationData[translationKey];

        return translatedValue || categoryName;
    }

    getCategoryDescription = (categoryName, eventTypeId = null) => {
        // If category is 'All' or 'Events Information', use translation key for description
        if (!categoryName || categoryName === 'All' || categoryName === 'Events Information') {
            const langKey = this.state.currentLanguage === 'ma' ? 'ma' : 'en';
            const translationData = langKey === 'ma' ? ma : en;
            return translationData['booknow_hero_desc'] ||
                "Choose between our Scientifically designed Residential Study Courses, 1-Day Workshops, Rational Poojas, Free Events and Machine Tests for holistic development and peace of mind.";
        }
        
        // First, try to get description from API (eventTypeDescriptions state)
        const { eventTypeDescriptions } = this.state;
        const normalizedInput = categoryName.trim();
        
        // If eventTypeId is provided, try to get description directly by ID
        if (eventTypeId && eventTypeDescriptions[eventTypeId]) {
            const eventTypeData = eventTypeDescriptions[eventTypeId];
            if (eventTypeData && eventTypeData.event_description) {
                return eventTypeData.event_description;
            }
        }
        
        // Try to find in API descriptions by event type name
        for (const [id, eventTypeData] of Object.entries(eventTypeDescriptions)) {
                if (eventTypeData && eventTypeData.event_type) {
                const eventTypeName = eventTypeData.event_type.trim();
                // Try exact match
                if (eventTypeName === normalizedInput) {
                    return eventTypeData.event_description || '';
                }
                // Try case-insensitive match
                if (eventTypeName.toLowerCase() === normalizedInput.toLowerCase()) {
                    return eventTypeData.event_description || '';
                }
            }
        }
        
        // Fallback to hardcoded descriptions if API data not available
        const descriptions = {
            'Residential Study Courses': "The Study Courses at 'New Way' are rational formulae for happiness, discovered after years of research. They suggest the ways to tackle the problems in life. They also suggest how one should approach life so as to remove the sources of grief that would affect life. All of the study courses are endowed with the theorems based on the confluence of three scientific approaches viz. Physics, Mathematics and Logic. All the study courses are conducted only at the main Manashakti Research Centre, Lonavla.",
            'One Day Workshops': "Experience transformative learning in just one day with our intensive workshops designed for busy professionals and individuals seeking quick yet effective solutions.",
            '1-Day Workshops': "Experience transformative learning in just one day with our intensive workshops designed for busy professionals and individuals seeking quick yet effective solutions.",
            'One Day Workshop': "Experience transformative learning in just one day with our intensive workshops designed for busy professionals and individuals seeking quick yet effective solutions.",
            'Machine Tests': "Test your knowledge and understanding through our scientifically designed machine tests that provide instant feedback and personalized recommendations.",
            'Machine Test': "Test your knowledge and understanding through our scientifically designed machine tests that provide instant feedback and personalized recommendations.",
            'Rational Poojas': "Experience traditional ceremonies with a rational and scientific approach, understanding the deeper meaning behind each ritual.",
            'Rational Pooja': "Experience traditional ceremonies with a rational and scientific approach, understanding the deeper meaning behind each ritual.",
            'Free Events': "Join our complimentary events and discover the power of rational thinking and scientific approaches to life's challenges.",
            'Free Event': "Join our complimentary events and discover the power of rational thinking and scientific approaches to life's challenges.",
            'Events Information': "Choose between our Scientifically designed Residential Study Courses, 1-Day Workshops, Rational Poojas, Free Events and Machine Tests for holistic development and peace of mind."
        };
        
        // Try exact match first
        if (descriptions[normalizedInput]) {
            return descriptions[normalizedInput];
        }
        
        // Try case-insensitive match
        const lowerInput = normalizedInput.toLowerCase();
        for (const [key, value] of Object.entries(descriptions)) {
            if (key.toLowerCase() === lowerInput) {
                return value;
            }
        }
        
        // Try partial match for variations (e.g., "1-Day" matches "1-Day Workshops")
        for (const [key, value] of Object.entries(descriptions)) {
            const lowerKey = key.toLowerCase();
            // Check if input contains key or key contains input (for partial matches)
            if (lowerKey.includes(lowerInput) || lowerInput.includes(lowerKey)) {
                // Make sure it's a meaningful match (not just matching common words)
                if (lowerInput.length >= 3 && lowerKey.length >= 3) {
                    return value;
                }
            }
        }
        
        // Map common variations to known categories
        const categoryVariations = {
            'one day': 'One Day Workshops',
            '1-day': '1-Day Workshops',
            'workshop': 'One Day Workshops',
            'rational pooja': 'Rational Poojas',
            'pooja': 'Rational Poojas',
            'free event': 'Free Events',
            'machine test': 'Machine Tests',
            'residential': 'Residential Study Courses',
            'study course': 'Residential Study Courses'
        };
        
        for (const [variation, mappedCategory] of Object.entries(categoryVariations)) {
            if (lowerInput.includes(variation)) {
                return descriptions[mappedCategory] || descriptions['Events Information'];
            }
        }
        
        // Default description
        return "Choose between our Scientifically designed Residential Study Courses, 1-Day Workshops, Rational Poojas, Free Events and Machine Tests for holistic development and peace of mind.";
    }

    // Map event type names to IDs (based on common event types or API filterOptions)
    mapEventTypeNameToId = (eventTypeName) => {
        // First try to find in API filterOptions
        const { filterOptions } = this.state;
        if (filterOptions.eventTypes && filterOptions.eventTypes.length > 0) {
            const eventType = filterOptions.eventTypes.find(et => 
                et.nameEn === eventTypeName || 
                et.nameMr === eventTypeName ||
                et.name === eventTypeName
            );
            if (eventType && eventType.id) {
                return eventType.id;
            }
        }
        
        // Fallback to hardcoded mapping
        // Normalize the event type name for matching
        const normalizedName = eventTypeName ? eventTypeName.trim() : '';
        const eventTypeMap = {
            'Residential Study Courses': 1,
            'One Day Workshops': 2,
            'One Day Workshop': 2,
            '1-Day Workshops': 2,
            '1-Day Workshop': 2,
            'Machine Tests': 3,
            'Machine Test': 3,
            'Rational Poojas': 4,
            'Rational Pooja': 4,
            'Free Events': 5,
            'Free Event': 5
        };
        // Try exact match first
        if (eventTypeMap[normalizedName]) {
            return eventTypeMap[normalizedName];
        }
        // Try case-insensitive match
        const lowerName = normalizedName.toLowerCase();
        for (const [key, value] of Object.entries(eventTypeMap)) {
            if (key.toLowerCase() === lowerName) {
                return value;
            }
        }
        return null;
    }

    // Map topic names to IDs using filterOptions from API
    mapTopicNameToId = (topicName) => {
        const { filterOptions } = this.state;
        
        // First try to find in API filterOptions
        if (filterOptions.topics && filterOptions.topics.length > 0) {
            // Topics from API might have different structures, try common formats
            const topic = filterOptions.topics.find(t => {
                // Check various possible field names for topic name
                const topicNameVariants = [
                    t.name,
                    t.nameEn,
                    t.nameMr,
                    t.label,
                    t.title,
                    t.titleEn,
                    t.titleMr,
                    t.topic_title,
                    t.topic_title_en,
                    t.topic_title_mr
                ];
                
                // Normalize for comparison (case-insensitive, trim whitespace)
                const normalizedTopicName = topicName.trim().toLowerCase();
                return topicNameVariants.some(variant => 
                    variant && variant.toString().trim().toLowerCase() === normalizedTopicName
                );
            });
            
            if (topic) {
                // Try various possible ID field names
                return topic.id || topic.topic_id || topic.topicId || null;
            }
        }
        
        // If not found in API, return null (will be filtered out)
        return null;
    }

    // Map subtopic names to IDs
    // Note: Subtopics are fetched dynamically when topics are selected
    // We need to match by label/name from the API response
    mapSubtopicNameToId = (subtopicName) => {
        // Subtopics are stored with their label/name from API
        // The ID should be in the availableSubtopics state, but we don't have direct access here
        // We'll need to pass subtopic IDs from EventFilters component, or store them differently
        
        // For now, try to extract ID from the subtopic name if it's in a specific format
        // This is a fallback - ideally subtopic IDs should be passed from EventFilters
        
        // Return null for now - we'll need to update EventFilters to pass IDs along with names
        return null;
    }

    // Resolve IDs from URL to names using filterOptions (for deep links with IDs)
    resolveIdsToNames = (filterOptions) => {
        if (!this.pendingIdResolve) {
            return null;
        }

        const resolved = {
            eventType: null,
            topics: [],
            subtopics: []
        };

        // Resolve event type ID to name
        if (this.pendingIdResolve.eventTypeId) {
            const eventTypeId = parseInt(this.pendingIdResolve.eventTypeId, 10);
            
            if (!isNaN(eventTypeId) && filterOptions && filterOptions.eventTypes) {
                const eventType = filterOptions.eventTypes.find(et => {
                    const id = et.id || et.event_type_id || et.eventTypeId;
                    return id === eventTypeId;
                });
                if (eventType) {
                    // Check for nameEn first (matching API response), then name, label, title
                    resolved.eventType = eventType.nameEn || eventType.name || eventType.label || eventType.title || null;
                }
            }
        }

        // Resolve topic IDs to names
        if (this.pendingIdResolve.topicIds && this.pendingIdResolve.topicIds.length > 0) {
            if (filterOptions && filterOptions.topics) {
                resolved.topics = this.pendingIdResolve.topicIds
                    .map(topicId => {
                        const topic = filterOptions.topics.find(t => 
                            (t.id || t.topic_id || t.topicId) === topicId
                        );
                        if (topic) {
                            return topic.name || topic.nameEn || topic.label || topic.title || topic.titleEn;
                        }
                        return null;
                    })
                    .filter(name => name !== null);
            }
        }

        // Note: Subtopic resolution would require fetching subtopics for the selected topics
        // This is more complex and requires async operations, so we'll store IDs and resolve them
        // when subtopics are fetched
        if (this.pendingIdResolve.subtopicIds && this.pendingIdResolve.subtopicIds.length > 0) {
            resolved.subtopicIds = this.pendingIdResolve.subtopicIds;
        }

        return resolved;
    }

    // Build API parameters from filter state
    buildApiParams = (filters, pagination) => {
        const params = {};
        const currentLanguage = getLanguage();
        
        // Add display language parameter (controls UI language - event titles, descriptions, etc.)
        // This is separate from languageId filter which filters events by the language they're conducted in
        params.language = currentLanguage === 'ma' ? 'ma' : 'en';
        
        // Map language filter to languageId (the language the event is conducted in)
        // Note: Display language is controlled by the top toggle (getLanguage()), NOT by this filter
        // Language IDs: 1=English, 2=Marathi, 3=Hindi
        if (filters.language && filters.language !== 'All') {
            if (filters.language === 'English') {
                params.languageId = 1;
            } else if (filters.language === 'Marathi') {
                params.languageId = 2;
            } else if (filters.language === 'Hindi') {
                params.languageId = 3;
            }
        }
        // When 'All' is selected, don't send languageId param to get events in all languages

        // Map event type IDs
        if (filters.events && filters.events.length > 0 && filters.events[0] !== 'All') {
            const eventTypeIds = filters.events
                .map(eventName => this.mapEventTypeNameToId(eventName))
                .filter(id => id !== null);
            if (filters.events && filters.events.length > 0 && filters.events[0] !== 'All') {
                const eventTypeIds = filters.events
                    .map(eventName => this.mapEventTypeNameToId(eventName))
                    .filter(id => id !== null);

                if (eventTypeIds.length > 0) {
                    params.eventTypeIds = eventTypeIds.join(',');
                }
            }
            if (eventTypeIds.length > 0) {
                params.eventTypeIds = eventTypeIds.join(',');
            }
        }

        // Map topic IDs (if available from filterOptions)
        if (filters.topics && filters.topics.length > 0 && !filters.topics.includes('All')) {
            const topicIds = filters.topics
                .map(topicName => this.mapTopicNameToId(topicName))
                .filter(id => id !== null && id !== undefined);
            
            if (topicIds.length > 0) {
                params.topicIds = topicIds.join(',');
            }
        }

        // Map subtopic IDs (if available from filters - IDs are passed directly from EventFilters)
        if (filters.subtopicIds && Array.isArray(filters.subtopicIds) && filters.subtopicIds.length > 0) {
            const subtopicIds = filters.subtopicIds
                .filter(id => id !== null && id !== undefined);
            
            if (subtopicIds.length > 0) {
                params.subtopicIds = subtopicIds.join(',');
            }
        } else if (filters.subTopics && filters.subTopics.length > 0 && !filters.subTopics.includes('All')) {
            // Fallback: try to map subtopic names to IDs
            const subtopicIds = filters.subTopics
                .map(subtopicName => this.mapSubtopicNameToId(subtopicName))
                .filter(id => id !== null && id !== undefined);
            
            if (subtopicIds.length > 0) {
                params.subtopicIds = subtopicIds.join(',');
            }
        }

        // Map hasSchedule filter (Active/Inactive)
        // if (filters.hasSchedule !== undefined && filters.hasSchedule !== null) {
        //     params.hasSchedule = filters.hasSchedule ? 'true' : 'false';
        // }

        // Apply hasSchedule only if explicitly set (Active / Inactive)
        // Do NOT force Active when status is 'All'
        if (
            filters.events &&
            !filters.events[0]?.toLowerCase().includes('machine')
        ) {
            if (filters.hasSchedule === true) {
                params.hasSchedule = 'true';
            } else if (filters.hasSchedule === false) {
                params.hasSchedule = 'false';
            }
            // If undefined → All → do not send hasSchedule
        }


        // Map age groups
        if (filters.topics && filters.topics.length > 0 && !filters.topics.includes('All')) {
            // Map topic names to age groups if they match
            const ageGroupMap = {
                'Prenatal': 'Adults',
                'Kids 8-14': 'Children',
                'Youth 14-28': 'Adults',
                'Adult/General': 'Adults'
            };
            const ageGroups = filters.topics
                .map(topic => ageGroupMap[topic])
                .filter(ageGroup => ageGroup)
                .filter((value, index, self) => self.indexOf(value) === index); // Remove duplicates
            if (ageGroups.length > 0) {
                params.ageGroups = ageGroups.join(',');
            }
        }

        // Pagination
        params.page = pagination.page || 1;
        params.pageSize = pagination.pageSize || 20;

        // Only apply status for non-machine events
        // if (
        //     filters.events &&
        //     !filters.events[0]?.toLowerCase().includes('machine')
        // ) {
        //     if (params.hasSchedule === undefined) {
        //         params.status = '1';
        //     }
        // }
        
        return params;
    }

    // Fetch filter options from API
    fetchFilterOptions = async () => {
        try {
            const currentLanguage = getLanguage();
            const langParam = currentLanguage === 'ma' ? 'ma' : 'en';
            const response = await fetch(`${myConstClass.NODE_API_BASE}/event/filterOptions?language=${langParam}`);
            const data = await response.json();
            
            if (data.status === 'true' && data.data) {
                this.setState({
                    filterOptions: {
                        eventTypes: data.data.eventTypes || [],
                        topics: data.data.topics || [],
                        ageGroups: data.data.ageGroups || [],
                        cities: data.data.cities || [],
                        states: data.data.states || [],
                        countries: data.data.countries || [],
                        trusts: data.data.trusts || []
                    }
                });
                return data.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    // Fetch machine tests from API using /event/filter endpoint (returns subtopics)
    // Fetch images for a specific event
    fetchEventImages = async (eventId, language = 'en') => {
        try {
            const apiUrl = `${myConstClass.NODE_API_BASE}/event/media/getImages/${eventId}/${language}`;
            const response = await fetch(apiUrl);

            if (!response.ok) {
                return null;
            }

            const images = await response.json();

            if (images && Array.isArray(images) && images.length > 0) {
                // Sort by sequence ascending (missing sequence goes to the end)
                const sorted = images.slice().sort((a, b) => {
                    const sa = (a && a.sequence !== undefined && a.sequence !== null) ? Number(a.sequence) : Number.MAX_SAFE_INTEGER;
                    const sb = (b && b.sequence !== undefined && b.sequence !== null) ? Number(b.sequence) : Number.MAX_SAFE_INTEGER;
                    return sa - sb;
                });

                // Pick first valid image (non-empty and not 'not-found.png') from sorted list
                const selected = sorted.find(img => img && img.image_url && img.image_url !== 'not-found.png');
                if (!selected) return null;

                const firstImage = selected.image_url;

                // Check if the image URL is absolute or relative
                if (firstImage && (firstImage.startsWith('http://') || firstImage.startsWith('https://'))) {
                    // Absolute URL - use as is
                    return firstImage;
                } else if (firstImage && firstImage !== 'not-found.png') {
                    // Relative path - prepend the base URL
                    const imagePath = firstImage.startsWith('uploads/') ? firstImage : `uploads/${firstImage}`;
                    const baseUrl = myConstClass.IMAGE_URL.replace('/uploads/user/', '/uploads/');
                    return `${baseUrl.replace(/\/+$/, '')}/${imagePath.replace(/^\/+/, '')}`;
                }
                return null;
            }

            return null;
        } catch (error) {
            console.error(`Error fetching images for event ${eventId}:`, error);
            return null;
        }
    }

    fetchMachineTests = async (filters = null, pagination = null, isInitialLoad = false) => {
        const currentFilters = filters || this.state.filters;
        const currentPagination = pagination || { ...this.state.pagination, page: 1, pageSize: 20 };
        const currentLanguage = getLanguage();
        
        if (isInitialLoad) {
            this.setState({ 
                loading: true,
                allLoadedMachineTests: [],
                displayedTestsCount: 6, // 2 rows of 3 cards
                hasMoreEvents: true
            });
        } else {
            this.setState({ loadingMore: true });
        }

        try {
            // Use the /event/filter API which returns subtopics
            const params = this.buildApiParams(currentFilters, currentPagination);
            // Ensure event type is set to Machine Tests (ID: 3)
            params.eventTypeIds = '3';
            // Ensure language parameter is included for machine tests
            params.language = currentLanguage === 'ma' ? 'ma' : 'en';
            
            const queryString = new URLSearchParams(params).toString();
            const apiUrl = `${myConstClass.NODE_API_BASE}/event/filter?${queryString}`;
            
            const response = await fetch(apiUrl);
            const data = await response.json();
            
            let machineTests = [];
            
            if (data.status === 'true' && data.data && data.data.length > 0) {
                // Transform API response to match MachineTestCard format
                // Fetch images for each machine test
                const currentLanguage = getLanguage();
                machineTests = await this.transformMachineTestsToCardFormat(data.data, currentLanguage);
                
                // Apply frontend language filter if specific language is selected (not 'All')
                // This ensures no machine test appears in the wrong language listing
                if (currentFilters.language && currentFilters.language !== 'All') {
                    const selectedLanguage = currentFilters.language; // 'English', 'Marathi', or 'Hindi'
                    machineTests = machineTests.filter(test => {
                        const testLang = test.language || 'English';
                        return testLang === selectedLanguage;
                    });
                }
            }
            
            // Update state with fetched data
            if (isInitialLoad) {
                const hasNextPage = data.pagination?.hasNextPage === true;
                const totalCount = data.pagination?.totalCount || machineTests.length;
                
                this.setState({
                    machineTests: machineTests,
                    allLoadedMachineTests: machineTests,
                    allLoadedEvents: [], // Clear regular events
                    loading: false,
                    hasMoreEvents: hasNextPage,
                    pagination: data.pagination || {
                        ...currentPagination,
                        totalCount: totalCount,
                        totalPages: data.pagination?.totalPages || 1,
                        hasNextPage: hasNextPage,
                        hasPreviousPage: false
                    }
                }, () => {
                    setTimeout(() => this.setupLazyLoadingObserver(), 500);
                });
            } else {
                const updatedTests = [...this.state.allLoadedMachineTests, ...machineTests];
                const hasNextPage = data.pagination?.hasNextPage === true;
                
                this.setState({
                    allLoadedMachineTests: updatedTests,
                    loadingMore: false,
                    hasMoreEvents: hasNextPage,
                    pagination: data.pagination || {
                        ...currentPagination,
                        totalCount: updatedTests.length
                    }
                }, () => {
                    setTimeout(() => this.setupLazyLoadingObserver(), 100);
                });
            }
        } catch (error) {
            this.setState({
                loading: false,
                loadingMore: false,
                hasMoreEvents: false
            });
            toast.error('Failed to load machine tests. Please try again.');
        }
    }
    
    // Transform machine test data from API to MachineTestCard format
    transformMachineTestsToCardFormat = async (apiMachineTests, language = 'en') => {
        const currentLanguage = getLanguage();
        const isMarathi = currentLanguage === 'ma';
        
        // Fetch images for all machine tests in parallel
        const testsWithImages = await Promise.all(
            apiMachineTests.map(async (test) => {
                // Extract subtopics from the API format
                let subtopics = [];
                if (test.subtopics && Array.isArray(test.subtopics) && test.subtopics.length > 0) {
                    subtopics = test.subtopics.map(subtopic => 
                        isMarathi ? (subtopic.titleMr || subtopic.titleEn || '') : (subtopic.titleEn || subtopic.titleMr || '')
                    ).filter(Boolean);
                }
                
                const subtopicDisplay = subtopics.length > 0 ? subtopics.join(' | ') : '';
                
                // Get topic information
                const topicInfo = this.getTopicInfoForEvent(test);
                
                // Fetch image from the API
                const imageUrl = await this.fetchEventImages(test.eventId, language);
                
                // Determine language label using languageId (same logic as regular events)
                let languageLabel = 'English'; // default
                if (test.languageId !== undefined && test.languageId !== null) {
                    const langId = Number(test.languageId);
                    if (langId === 1) {
                        languageLabel = 'English';
                    } else if (langId === 2) {
                        languageLabel = 'Marathi';
                    } else if (langId === 3) {
                        languageLabel = 'Hindi';
                    }
                } else {
                    // Fallback to language code fields
                    const testLanguage = test.language || test.event_language || test.lang || test.languageCode || '';
                    const langCode = testLanguage.toLowerCase().trim();
                    if (langCode === 'ma' || langCode === 'marathi' || langCode === 'mr') {
                        languageLabel = 'Marathi';
                    } else if (langCode === 'hi' || langCode === 'hindi') {
                        languageLabel = 'Hindi';
                    } else {
                        languageLabel = 'English';
                    }
                }
                
                // Prefer description fields: description, descriptionEn, descriptionMr, descriptionHtml
                let description = '';
                if (isMarathi) {
                    description = test.descriptionMr || test.description || test.descriptionEn || test.descriptionHtml || '';
                } else {
                    description = test.descriptionEn || test.description || test.descriptionMr || test.descriptionHtml || '';
                }
                // If description is Draft.js JSON, parse to plain text
                if (description && (typeof description === 'string') && (description.trim().startsWith('{') || description.trim().startsWith('['))) {
                    description = this.parseDraftJsToText(description);
                }
                return {
                    event_id: test.eventId,
                    title: (isMarathi ? (test.titleMr || test.title || test.titleEn) : (test.titleEn || test.title || test.titleMr)) || '',
                    age_group: test.ageGroup || '',
                    first_price: test.firstPrice || 0,
                    first_price_for: test.firstPriceFor || 'Person',
                    topic_id_value: test.topicId || topicInfo?.topicId || null,
                    image_name: imageUrl || test.imageUrl || test.image_url || test.imageName || null,
                    added_in_cart: [],
                    language: languageLabel, // Add language property for filtering
                    // Add subtopic information
                    subtopics: subtopics,
                    // Extract subtopic IDs if provided by API
                    subtopicIds: (test.subtopics && Array.isArray(test.subtopics)) ? test.subtopics.map(s => s.id).filter(id => id !== null && id !== undefined) : [],
                    // Provide topic name and id for navigation (if available)
                    topicName: topicInfo ? topicInfo.originalName : (isMarathi ? (test.topicTitleMr || test.topicTitle || test.topicName) : (test.topicTitleEn || test.topicTitle || test.topicName)) || null,
                    topicId: topicInfo ? topicInfo.topicId : (test.topicId || null),
                    subtopicDisplay: subtopicDisplay,
                    category_label: topicInfo ? topicInfo.displayName : '',
                    description: description
                };
            })
        );
        
        return testsWithImages;
    }

    // Fetch filtered events from API
    fetchFilteredEvents = async (filters = null, pagination = null, isInitialLoad = false) => {
        const currentFilters = filters || this.state.filters;
        const currentPagination = pagination || { ...this.state.pagination, page: 1 };
        
        // Reset state for new filter/search
        if (isInitialLoad) {
            this.setState({ 
                loading: true,
                displayedEventsCount: 10,
                allLoadedEvents: [],
                hasMoreEvents: true
            });
        } else {
            this.setState({ loading: true });
        }

        try {
            const params = this.buildApiParams(currentFilters, currentPagination);
            const queryString = new URLSearchParams(params).toString();
            const apiUrl = `${myConstClass.NODE_API_BASE}/event/filter?${queryString}`;
            
            const response = await fetch(apiUrl);
            const data = await response.json();

            if (data.status === 'true') {
                // Debug: Log first event to see what fields API returns
                if (data.data && data.data.length > 0) {
                    // console.log('📊 First event from API:', data.data[0]);
                    // console.log('📊 Has schedule field check:', {
                    //     hasSchedule: data.data[0].hasSchedule,
                    //     has_schedule: data.data[0].has_schedule,
                    //     scheduleCount: data.data[0].scheduleCount,
                    //     schedule_count: data.data[0].schedule_count
                    // });
                }
                
                // Transform API response to match EventCardNew format
                let transformedEvents = this.transformApiEventsToCardFormat(data.data || []);
                
                // Apply frontend language filter if specific language is selected (not 'All')
                // This ensures no event appears in the wrong language listing
                if (currentFilters.language && currentFilters.language !== 'All') {
                    const selectedLanguage = currentFilters.language; // 'English', 'Marathi', or 'Hindi'
                    transformedEvents = transformedEvents.filter(event => {
                        const eventLang = event.language || 'English';
                        return eventLang === selectedLanguage;
                    });
                    
                }
                
                
                // Check if there are more events available - rely on API pagination response
                const stillHasMore = data.pagination?.hasNextPage === true;
                
                // Also check total count for verification
                const totalCount = data.pagination?.totalCount || 0;
                const hasMoreByCount = totalCount > 0 && transformedEvents.length < totalCount;
                
                
                
                // Use hasNextPage if available, otherwise fall back to count comparison
                const finalHasMore = stillHasMore !== undefined ? stillHasMore : hasMoreByCount;
                
                this.setState({
                    events: transformedEvents,
                    allLoadedEvents: transformedEvents, // Store all loaded events
                    filteredEvents: transformedEvents, // Keep all for compatibility
                    pagination: data.pagination || currentPagination,
                    hasMoreEvents: finalHasMore,
                    loading: false
                }, () => {
                    // Setup lazy loading observer after initial load
                    if (isInitialLoad) {
                        setTimeout(() => this.setupLazyLoadingObserver(), 100);
                    }
                });
            } else {
                console.error('API Error:', data.message);
                this.setState({
                    events: [],
                    allLoadedEvents: [],
                    filteredEvents: [],
                    hasMoreEvents: false,
                    loading: false
                });
            }
        } catch (error) {
            this.setState({
                events: [],
                allLoadedEvents: [],
                filteredEvents: [],
                hasMoreEvents: false,
                loading: false
            });
        }
    }

    // Helper function to parse Draft.js JSON to plain text
    parseDraftJsToText = (draftJsContent) => {
        if (!draftJsContent) return '';
        
        // If it's already a plain string and doesn't look like JSON, return as-is
        if (typeof draftJsContent === 'string' && !draftJsContent.trim().startsWith('{') && !draftJsContent.trim().startsWith('[')) {
            return draftJsContent;
        }
        
        let parsed;
        
        // Check if it's a string that might be JSON
        if (typeof draftJsContent === 'string') {
            try {
                parsed = JSON.parse(draftJsContent);
            } catch (e) {
                // Not valid JSON, return as-is
                return draftJsContent;
            }
        } else if (typeof draftJsContent === 'object') {
            parsed = draftJsContent;
        } else {
            return String(draftJsContent);
        }
        
        // Check if it has the Draft.js structure (blocks array)
        if (parsed && parsed.blocks && Array.isArray(parsed.blocks)) {
            // Extract text from all blocks
            const text = parsed.blocks
                .map(block => {
                    // Handle different block types
                    if (block.text) {
                        return block.text;
                    }
                    // For list items, add bullet or number
                    if (block.type === 'unordered-list-item') {
                        return '• ' + (block.text || '');
                    }
                    if (block.type === 'ordered-list-item') {
                        return (block.text || '');
                    }
                    return '';
                })
                .filter(text => text && text.trim())
                .join(' ')
                .trim();
            
            // Limit description length for card display (optional - you can adjust this)
            if (text.length > 200) {
                return text.substring(0, 200) + '...';
            }
            
            return text;
        }
        
        // Return as-is if not Draft.js format
        return typeof draftJsContent === 'string' ? draftJsContent : String(draftJsContent);
    }

    // Helper function to parse Draft.js JSON to HTML (for rich content)
    parseDraftJsToHTML = (draftJsContent) => {
        if (!draftJsContent) return '';
        
        try {
            let parsed;
            
            // Check if it's a string that might be JSON
            if (typeof draftJsContent === 'string') {
                parsed = JSON.parse(draftJsContent);
            } else if (typeof draftJsContent === 'object') {
                parsed = draftJsContent;
            } else {
                return draftJsContent;
            }
            
            // Check if it has the Draft.js structure
            if (parsed && parsed.blocks && Array.isArray(parsed.blocks)) {
                try {
                    const editorState = convertFromRaw(parsed);
                    return stateToHTML(editorState.getCurrentContent());
                } catch (e) {
                    // Fallback to plain text extraction
                    return this.parseDraftJsToText(draftJsContent);
                }
            }
        } catch (e) {
            // Not Draft.js format, return as-is
            return draftJsContent;
        }
        
        return draftJsContent;
    }

    // Helper function to format/clean topic name for display
    formatTopicNameForDisplay = (topicName) => {
        if (!topicName) return '';
        
        let formatted = topicName.trim();
        
        // Pattern 1: "Child Development: 8 to 14 years" → "8 to 14 years"
        // Pattern 2: "Youth Power: 15 to 28 years" → "15 to 28 years"
        // Pattern 3: "Nurturing Kids: Birth up to 7 years" → "Birth up to 7 years"
        const colonPattern = /^[^:]+:\s*(.+)$/;
        const colonMatch = formatted.match(colonPattern);
        if (colonMatch) {
            formatted = colonMatch[1].trim();
        }
        
        // Pattern 4: "Suprajanan (Newly Wed Couples)" → "Newly Wed Couples"
        const parenthesesPattern = /^[^(]+\(([^)]+)\)$/;
        const parenthesesMatch = formatted.match(parenthesesPattern);
        if (parenthesesMatch) {
            formatted = parenthesesMatch[1].trim();
        }
        
        return formatted;
    }

    // Helper function to get topic information (name, id, original name) from event or filterOptions
    getTopicInfoForEvent = (event) => {
        const { filterOptions } = this.state;
        const currentLanguage = getLanguage();
        const isMarathi = currentLanguage === 'ma';
        
        // First, try to get topic directly from event object (check language-specific fields first)
        const topicFromEvent = (() => {
            if (isMarathi) {
                return event.topicTitleMr || event.topicMr || event.topicTitle || event.topic || event.topicName || event.topic_title_mr || event.topic_title || event.topic_title_en || '';
            }
            // Default (English) preference
            return event.topicTitleEn || event.topicTitle || event.topicEn || event.topic || event.topicName || event.topic_title_en || event.topic_title || event.topic_title_mr || '';
        })();
        
        const topicId = event.topicId || event.topic_id || event.topicIdFk || event.topic_id_fk;
        
        if (topicFromEvent && topicId) {
            return {
                displayName: this.formatTopicNameForDisplay(topicFromEvent),
                originalName: topicFromEvent,
                topicId: topicId
            };
        }
        
        // If topic not found in event, try to look it up from filterOptions using topicId
        if (topicId && filterOptions.topics && filterOptions.topics.length > 0) {
            const topic = filterOptions.topics.find(t => {
                const id = t.id || t.topic_id || t.topicId;
                return id && (id.toString() === topicId.toString() || id === topicId);
            });
            
            if (topic) {
                // Get the appropriate language version
                const topicName = isMarathi 
                    ? (topic.nameMr || topic.titleMr || topic.topic_title_mr || topic.name || topic.title || topic.topic_title || '')
                    : (topic.nameEn || topic.titleEn || topic.topic_title_en || topic.name || topic.title || topic.topic_title || '');
                return {
                    displayName: this.formatTopicNameForDisplay(topicName),
                    originalName: topicName,
                    topicId: topicId
                };
            }
        }
        
        // If topic not found, check if event has subtopic information and get parent topic
        // Check for subtopic ID in event
        const subtopicId = event.subtopicId || event.subtopic_id || event.subTopicId || event.sub_topic_id || 
                          event.subtopicIdFk || event.subtopic_id_fk || event.subTopicIdFk || event.sub_topic_id_fk;
        const subtopicTopicId = event.subtopicTopicId || event.subtopic_topic_id || event.subTopicTopicId || 
                               event.sub_topic_topic_id || event.topicIdFk || event.topic_id_fk;
        
        // If we have a parent topic ID from subtopic, look it up
        if (subtopicTopicId && filterOptions.topics && filterOptions.topics.length > 0) {
            const topic = filterOptions.topics.find(t => {
                const id = t.id || t.topic_id || t.topicId;
                return id && (id.toString() === subtopicTopicId.toString() || id === subtopicTopicId);
            });
            
            if (topic) {
                const topicName = isMarathi 
                    ? (topic.nameMr || topic.titleMr || topic.topic_title_mr || topic.name || topic.title || topic.topic_title || '')
                    : (topic.nameEn || topic.titleEn || topic.topic_title_en || topic.name || topic.title || topic.topic_title || '');
                return {
                    displayName: this.formatTopicNameForDisplay(topicName),
                    originalName: topicName,
                    topicId: subtopicTopicId
                };
            }
        }
        
        // If still not found, return null
        return null;
    }

    // Helper function to get topic name from event or filterOptions (for backward compatibility)
    getTopicNameForEvent = (event) => {
        const topicInfo = this.getTopicInfoForEvent(event);
        return topicInfo ? topicInfo.displayName : '';
    }

    // Transform API event format to EventCardNew component format
    transformApiEventsToCardFormat = (apiEvents) => {
        const currentLanguage = getLanguage();
        const isMarathi = currentLanguage === 'ma';
        
        return apiEvents.map(event => {
            // Build pricing array
            const pricing = [];
            if (event.firstPrice) {
                pricing.push({
                    amount: event.firstPrice,
                    label: event.firstPriceFor || 'person'
                });
            }
            if (event.secondPrice) {
                pricing.push({
                    amount: event.secondPrice,
                    label: event.secondPriceFor || 'person'
                });
            }

            // Determine language label from API language field
            // Determine language label using languageId (primary) or language code (fallback)
            let languageLabel = 'English'; // default

            // Priority 1: languageId from API
            if (event.languageId !== undefined && event.languageId !== null) {
                const langId = Number(event.languageId);

                if (langId === 1) {
                    languageLabel = 'English';
                } else if (langId === 2) {
                    languageLabel = 'Marathi';
                } else if (langId === 3) {
                    languageLabel = 'Hindi';
                }
            } else {
                // Fallback to language code fields
                const eventLanguage = event.language || event.event_language || event.lang || event.languageCode || '';
                const langCode = eventLanguage.toLowerCase().trim();

                if (langCode === 'ma' || langCode === 'marathi' || langCode === 'mr') {
                    languageLabel = 'Marathi';
                } else if (langCode === 'hi' || langCode === 'hindi') {
                    languageLabel = 'Hindi';
                } else {
                    languageLabel = 'English';
                }
            }


            // Extract keywords from description or use empty array
            // Note: API might not provide keywords, so we'll use an empty array
            const keywords = [];

            // Get description and parse if it's Draft.js format
            // Prefer language-specific description fields when available
            let description = isMarathi
                ? (event.descriptionMr || event.description || event.descriptionEn || '')
                : (event.descriptionEn || event.description || event.descriptionMr || '');
            
            // Parse Draft.js format if needed
            // Check if description is a Draft.js JSON string or object
            if (description) {
                const isDraftJsString = typeof description === 'string' && 
                    (description.trim().startsWith('{') || description.trim().startsWith('['));
                const isDraftJsObject = typeof description === 'object' && 
                    description !== null && 
                    description.blocks && 
                    Array.isArray(description.blocks);
                
                if (isDraftJsString || isDraftJsObject) {
                    description = this.parseDraftJsToText(description);
                }
            }

            // Get topic information for category_label and navigation
            const topicInfo = this.getTopicInfoForEvent(event);

            // Extract subtopics (language-aware). Backend may return:
            // 1. Object array: event.subtopics with titleEn/titleMr properties (new format for machine tests)
            // 2. String arrays: subtopicTitlesEn, subtopicTitlesMr, subtopicIds (old format)
            let subtopics = [];
            let subtopicIds = [];
            
            // Check if subtopics are in new object format (for machine tests)
            if (event.subtopics && Array.isArray(event.subtopics) && event.subtopics.length > 0) {
                // New format: array of objects with titleEn/titleMr
                subtopics = event.subtopics.map(subtopic => 
                    isMarathi ? (subtopic.titleMr || subtopic.titleEn || '') : (subtopic.titleEn || subtopic.titleMr || '')
                ).filter(Boolean);
                
                subtopicIds = event.subtopics.map(subtopic => subtopic.id).filter(id => id !== null && id !== undefined);
            } else {
                // Old format: string arrays
                const subtopicTitlesRaw = isMarathi
                    ? (event.subtopicTitlesMr || event.subtopicTitles || event.subtopicTitlesEn)
                    : (event.subtopicTitlesEn || event.subtopicTitles || event.subtopicTitlesMr);
                subtopics = Array.isArray(subtopicTitlesRaw) ? subtopicTitlesRaw.filter(Boolean) : [];
                
                // Extract subtopic IDs (may come as array from API)
                const subtopicIdsRaw = event.subtopicIds || event.subtopic_ids || event.subTopicIds || event.sub_topic_ids || [];
                subtopicIds = Array.isArray(subtopicIdsRaw) 
                    ? subtopicIdsRaw.filter(id => id !== null && id !== undefined) 
                    : [];
            }
            
            const subtopicDisplay = subtopics.length > 0 ? subtopics.slice(0, 2).join(' | ') : '';
            
            

            return {
                event_id: event.eventId,
                category_label: topicInfo ? topicInfo.displayName : '', // Use topic name instead of ageGroup
                topicId: topicInfo ? topicInfo.topicId : null, // Topic ID for navigation
                topicName: topicInfo ? topicInfo.originalName : null, // Original topic name for URL
                subtopics: subtopics,
                subtopicIds: subtopicIds, // Include subtopic IDs for navigation
                subtopicDisplay: subtopicDisplay,
                title: (isMarathi ? (event.titleMr || event.title || event.titleEn) : (event.titleEn || event.title || event.titleMr)) || '',
                description: description,
                keywords: keywords,
                language: languageLabel,
                pricing: pricing,
                background_icon: null, // API doesn't provide this, can be set later
                eventType: (isMarathi ? (event.eventTypeMr || event.eventType || event.eventTypeEn) : (event.eventTypeEn || event.eventType || event.eventTypeMr)) || '',
                eventTypeId: event.eventTypeId,
                trustName: event.trustName || '',
                trustId: event.trustId,
                // Map server-provided schedule metadata (new fields from backend)
                futureScheduleCount: (event.futureScheduleCount !== undefined && event.futureScheduleCount !== null)
                    ? Number(event.futureScheduleCount)
                    : (event.scheduleCount !== undefined && event.scheduleCount !== null)
                        ? Number(event.scheduleCount)
                        : (event.schedule_count !== undefined && event.schedule_count !== null)
                            ? Number(event.schedule_count)
                            : undefined,
                hasActiveSchedule: (event.hasActiveSchedule !== undefined && event.hasActiveSchedule !== null)
                    ? Boolean(event.hasActiveSchedule)
                    : (event.futureScheduleCount !== undefined && event.futureScheduleCount !== null)
                        ? Number(event.futureScheduleCount) > 0
                        : (event.scheduleCount !== undefined && event.scheduleCount !== null)
                            ? Number(event.scheduleCount) > 0
                            : (event.hasSchedule !== undefined && event.hasSchedule !== null)
                                ? Boolean(event.hasSchedule)
                                : undefined,
                // Preserve legacy hasSchedule boolean for backward-compatibility
                hasSchedule: ((event.hasActiveSchedule !== undefined && event.hasActiveSchedule !== null)
                    ? Boolean(event.hasActiveSchedule)
                    : (event.futureScheduleCount !== undefined && event.futureScheduleCount !== null)
                        ? Number(event.futureScheduleCount) > 0
                        : (event.scheduleCount !== undefined && event.scheduleCount !== null)
                            ? Number(event.scheduleCount) > 0
                            : (event.hasSchedule !== undefined && event.hasSchedule !== null)
                                ? Boolean(event.hasSchedule)
                                : undefined),
                // Next future schedule date if provided by backend
                nextScheduleDate: event.nextScheduleDate || event.next_schedule_date || null
            };
        });
    }

    handleFilterChange = (filters) => {
        // Check if Machine Tests is selected
        const isMachineTests = filters.events && filters.events[0] === 'Machine Tests';

        // Auto-adjust hasSchedule based on event type
        if (isMachineTests) {
            filters.hasSchedule = undefined; // Machine Tests → All
        } 
        
        this.setState({ 
            filters,
            pagination: { ...this.state.pagination, page: 1 }, // Reset to page 1 on filter change
            displayedEventsCount: 10, // Reset displayed count
            displayedTestsCount: 6, // Reset machine test displayed count
            allLoadedEvents: [], // Clear loaded events
            allLoadedMachineTests: [] // Clear loaded machine tests
        }, () => {
                // Fetch after state is updated
                if (isMachineTests) {
                    this.fetchMachineTests(filters, { ...this.state.pagination, page: 1 }, true);
                } else {
                    this.fetchFilteredEvents(filters, { ...this.state.pagination, page: 1 }, true);
                }
            });
        
        // Update URL when event filter changes (to match navbar behavior)
        if (filters.events && filters.events.length > 0 && filters.events[0] !== 'All') {
            const eventTypeName = filters.events[0];
            const eventTypeId = this.mapEventTypeNameToId(eventTypeName);
            
            if (eventTypeId) {
                // Build the new URL path
                const newPath = `/booknow/${encodeURIComponent(eventTypeName)}/${eventTypeId}`;
                
                // Pass complete filter state for back navigation
                const locationState = {
                    topics: filters.topics || ['All'],
                    subTopics: filters.subTopics || ['All'],
                    subtopicIds: filters.subtopicIds || [],
                    language: filters.language || 'All',
                    hasSchedule: filters.hasSchedule,
                    // Keep backward compatibility with single topic
                    selectedTopic: filters.topics && filters.topics.length > 0 && filters.topics[0] !== 'All' 
                        ? filters.topics[0] 
                        : null
                };
                
                // Update URL without page reload
                this.props.history.push({
                    pathname: newPath,
                    state: locationState
                });
                
                // Update state with new category info
                this.setState({
                    categoryName: eventTypeName,
                    categoryId: eventTypeId.toString()
                });
                
                // Fetch event type description when event filter changes
                const language = getLanguage();
                this.fetchAndStoreEventTypeDescription(eventTypeId, language, eventTypeName);
            }
        } else {
            // For other filter changes (topics, language, hasSchedule etc.), update current history state
            try {
                this.props.history.replace({
                    pathname: this.props.location.pathname,
                    state: {
                        topics: filters.topics || ['All'],
                        subTopics: filters.subTopics || ['All'],
                        subtopicIds: filters.subtopicIds || [],
                        language: filters.language || 'All',
                        hasSchedule: filters.hasSchedule,
                        selectedTopic: filters.topics && filters.topics.length > 0 && filters.topics[0] !== 'All' ? filters.topics[0] : null
                    }
                });
            } catch (e) {
                // ignore history errors
            }
        }
        
        // Fetch machine tests or regular events based on filter
        // if (isMachineTests) {
        //     this.fetchMachineTests(filters, { ...this.state.pagination, page: 1 }, true);
        // } else {
        //     this.fetchFilteredEvents(filters, { ...this.state.pagination, page: 1 }, true);
        // }
    }

    // Removed handlePageChange - no longer needed with lazy loading

    componentDidUpdate(prevProps) {
        // Check if display language changed (from top English/Marathi toggle)
        const newLanguage = getLanguage();
        if (newLanguage !== this.state.currentLanguage) {
            console.log('Language changed from', this.state.currentLanguage, 'to', newLanguage);
            
            // Re-fetch events with new language to get correct titles/descriptions
            const { allLoadedEvents, allLoadedMachineTests, filters } = this.state;
            // Determine selected category/type so we can reload its description in the new language
            const selectedEventCategory = filters.events && filters.events.length > 0 ? filters.events[0] : this.state.categoryName;
            const selectedEventTypeId = selectedEventCategory && selectedEventCategory !== 'Events Information'
                ? this.mapEventTypeNameToId(selectedEventCategory)
                : this.state.categoryId || '';
            const isMachineTests = filters.events && filters.events[0] === 'Machine Tests';
            
            if (isMachineTests && allLoadedMachineTests.length > 0) {
                // Re-fetch machine tests to get language-specific content
                this.setState({ currentLanguage: newLanguage }, () => {
                    this.fetchMachineTests(filters, { ...this.state.pagination, page: 1 }, true);
                    // Also refresh category/event type description in the selected language
                    if (selectedEventTypeId) {
                        this.fetchAndStoreEventTypeDescription(selectedEventTypeId, newLanguage, selectedEventCategory);
                    }
                });
            } else if (allLoadedEvents.length > 0) {
                // Re-fetch regular events to get language-specific content
                this.setState({ currentLanguage: newLanguage }, () => {
                    this.fetchFilteredEvents(filters, { ...this.state.pagination, page: 1 }, true);
                    // Also refresh category/event type description in the selected language
                    if (selectedEventTypeId) {
                        this.fetchAndStoreEventTypeDescription(selectedEventTypeId, newLanguage, selectedEventCategory);
                    }
                });
            } else {
                // Just update the language state (no events loaded yet)
                this.setState({ currentLanguage: newLanguage }, () => {
                    if (selectedEventTypeId) {
                        this.fetchAndStoreEventTypeDescription(selectedEventTypeId, newLanguage, selectedEventCategory);
                    }
                });
            }
            return; // Exit early, don't process other updates
        }
        
        // Handle route parameter changes (e.g., from browser back/forward or direct URL navigation)
        const { categoryName, categoryId } = this.props.match.params;
        const locationState = this.props.location.state || {};
        const prevLocationState = prevProps.location.state || {};
        
        // Get topics arrays for comparison
        const currentTopics = locationState.topics || (locationState.selectedTopic ? [locationState.selectedTopic] : null);
        const prevTopics = prevLocationState.topics || (prevLocationState.selectedTopic ? [prevLocationState.selectedTopic] : null);
        
        // Get subtopics arrays for comparison
        const currentSubTopics = locationState.subTopics || (locationState.selectedSubtopic ? [locationState.selectedSubtopic] : null);
        const prevSubTopics = prevLocationState.subTopics || (prevLocationState.selectedSubtopic ? [prevLocationState.selectedSubtopic] : null);
        
        // Check if filters changed
        const topicsChanged = JSON.stringify(currentTopics) !== JSON.stringify(prevTopics);
        const subTopicsChanged = JSON.stringify(currentSubTopics) !== JSON.stringify(prevSubTopics);
        const languageChanged = locationState.language !== prevLocationState.language;
        
        // Check if URL parameters or location state changed
        const urlChanged = 
            prevProps.match.params.categoryName !== categoryName ||
            prevProps.match.params.categoryId !== categoryId ||
            topicsChanged ||
            subTopicsChanged ||
            languageChanged;
        
        if (urlChanged) {
            const decodedCategoryName = decodeURIComponent(categoryName || '');
            
            // Check if topic or subtopic changed (even if URL category is the same)
            const topicChanged = topicsChanged;
            const subtopicChanged = subTopicsChanged;
            const topicOrSubtopicChanged = topicChanged || subtopicChanged;
            
            // Check if the current filters already match the URL (to avoid duplicate fetches)
            const currentEventFilter = this.state.filters.events && this.state.filters.events.length > 0 
                ? this.state.filters.events[0] 
                : '';
            const urlMatchesCurrentFilter = decodedCategoryName === currentEventFilter || 
                (!decodedCategoryName && currentEventFilter === 'Residential Study Courses');
            
            // Check if current filters match the new topics/subtopics
            const currentTopicsArray = this.state.filters.topics || ['All'];
            const currentSubtopicsArray = this.state.filters.subTopics || ['All'];
            
            // Compare arrays
            const filtersMatchTopics = JSON.stringify(currentTopicsArray) === JSON.stringify(currentTopics || ['All']);
            const filtersMatchSubtopics = JSON.stringify(currentSubtopicsArray) === JSON.stringify(currentSubTopics || ['All']);
            
            
            
            // Update filters if:
            // 1. URL category changed (and doesn't match current filter), OR
            // 2. Topics or subtopics changed (even if URL category is the same)
            const shouldUpdateFilters = !urlMatchesCurrentFilter || 
                (topicOrSubtopicChanged && (!filtersMatchTopics || !filtersMatchSubtopics));
            
            if (shouldUpdateFilters) {
                // Handle topics - can be an array or single value
                let topicsFilter = ['All'];
                if (locationState.topics && Array.isArray(locationState.topics)) {
                    topicsFilter = locationState.topics;
                } else if (locationState.selectedTopic) {
                    topicsFilter = [locationState.selectedTopic];
                } else {
                    topicsFilter = this.state.filters.topics || ['All'];
                }
                
                // Handle subtopics - can be an array or single value
                let subTopicsFilter = ['All'];
                if (locationState.subTopics && Array.isArray(locationState.subTopics)) {
                    subTopicsFilter = locationState.subTopics;
                } else if (locationState.selectedSubtopic) {
                    subTopicsFilter = [locationState.selectedSubtopic];
                }
                
                // Handle subtopic IDs
                const subtopicIds = locationState.subtopicIds || (locationState.subtopicId ? [locationState.subtopicId] : []);
                
                // Handle language
                const languageFilter = locationState.language || this.state.filters.language || 'All';
                
                // Update filters with the new category from URL and filters from location state
                const eventTypeId = this.mapEventTypeNameToId(decodedCategoryName);

                const updatedFilters = {
                    events: decodedCategoryName ? [decodedCategoryName] : ['Residential Study Courses'],
                    topics: topicsFilter,
                    language: languageFilter,
                    subTopics: subTopicsFilter,
                    subtopicIds: subtopicIds,
                    hasSchedule: eventTypeId === 3 ? undefined : true
                };
                
                this.setState({
                    categoryName: decodedCategoryName,
                    categoryId: categoryId || '',
                    filters: updatedFilters,
                    pagination: { ...this.state.pagination, page: 1 },
                    displayedEventsCount: 10,
                    allLoadedEvents: []
                });
                
                window.scrollTo(0, 0);
                
                // Fetch new events data with updated filters (initial load)
                // this.fetchFilteredEvents(updatedFilters, { ...this.state.pagination, page: 1 }, true);

                const isMachineTests = eventTypeId === 3;

                if (isMachineTests) {
                    this.fetchMachineTests(updatedFilters, { ...this.state.pagination, page: 1 }, true);
                } else {
                    this.fetchFilteredEvents(updatedFilters, { ...this.state.pagination, page: 1 }, true);
                }
                
                // Fetch event type description when category changes
                if (categoryId && !urlMatchesCurrentFilter) {
                    const language = getLanguage();
                    this.fetchAndStoreEventTypeDescription(categoryId, language, decodedCategoryName);
                } else if (decodedCategoryName && !urlMatchesCurrentFilter) {
                    // If no categoryId, try to get it from the category name
                    const eventTypeId = this.mapEventTypeNameToId(decodedCategoryName);
                    if (eventTypeId) {
                        const language = getLanguage();
                        this.fetchAndStoreEventTypeDescription(eventTypeId, language, decodedCategoryName);
                    }
                }
            } else {
                // URL matches current filter and filters already match topic/subtopic
                // Just update category state (URL was updated programmatically)
                this.setState({
                    categoryName: decodedCategoryName,
                    categoryId: categoryId || ''
                });
            }
        }
    }

    // Add machine test to cart - first show appointment alert modal
    handleAddToCart = async (eventId, quantity, topicId) => {
        if (quantity <= 0) {
            const message = getLanguage() === 'ma' ? 'कृपया सहभागींची संख्या निवडा.' : 'Please select the number of participants.';
            toast.error(message);
            return;
        }
        
        // Store data temporarily and show modal
        this.setState({
            tempCartData: {
                eventId,
                quantity,
                topicId
            }
        }, () => {
            // Show the appointment alert modal
            $('#MachineTestModal').modal('show');
        });
    }
    
    // Continue adding to cart after modal confirmation
    addToCartContinue = async () => {
        // Hide modal
        $('#MachineTestModal').modal('hide');
        
        const { tempCartData } = this.state;
        if (!tempCartData) return;
        
        const { eventId, quantity, topicId } = tempCartData;
        const userId = localStorage.getItem('user_id');
        
        if (!userId || userId === '0') {
            // Guest user - store in guest_mt_cart
            try {
                const guestMtCart = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
                const machineTest = this.state.allLoadedMachineTests.find(mt => mt.event_id == eventId);
                if (!machineTest) {
                    toast.error('Machine test not found');
                    return;
                }
                const existingIndex = guestMtCart.findIndex(item => item.event_id == eventId && item.topic_id == topicId);
                if (existingIndex !== -1) {
                    guestMtCart[existingIndex].parent = parseInt(guestMtCart[existingIndex].parent || 0) + parseInt(quantity);
                } else {
                    guestMtCart.push({
                        event_id: eventId,
                        event_type: 'Machine Test',
                        event_type_id: 3,
                        topic_id: topicId,
                        parent: parseInt(quantity),
                        child: 0,
                        title: machineTest.title,
                        price: machineTest.first_price,
                        first_price: machineTest.first_price,
                        second_price: machineTest.second_price || machineTest.first_price,
                        child_price: machineTest.second_price || machineTest.first_price,
                        first_price_for: machineTest.first_price_for || 'Person',
                        added_at: new Date().toISOString()
                    });
                }
                localStorage.setItem('guest_mt_cart', JSON.stringify(guestMtCart));
                updateGuestCartDisplay();
                this.setState(prevState => ({
                    allLoadedMachineTests: prevState.allLoadedMachineTests.map(mt =>
                        mt.event_id == eventId
                            ? { ...mt, added_in_cart: [{ cart_id: 1 }] }
                            : mt
                    )
                }));
                toast.success('Machine test added in cart');
            } catch (error) {
                console.error('Error adding machine test to guest machine test cart:', error);
                toast.error('Unable to add machine test to cart');
            }
        } else {
            // Logged-in user - use the same API as MachineTestWidget
            try {
                const url = myConstClass.BASE_URL + `cart/addMachineTestEventToCart/${eventId}/${userId}/${quantity}/0`;
                const response = await fetch(url, { method: 'GET' });
                const data = await response.json();
                if (data.status === 'true') {
                    toast.success('Machine test added in cart');
                    this.setState(prevState => ({
                        allLoadedMachineTests: prevState.allLoadedMachineTests.map(mt =>
                            mt.event_id == eventId
                                ? { ...mt, added_in_cart: [{ cart_id: 1 }] }
                                : mt
                        )
                    }));
                    // Update cart count in header using the fixed getCartDisplayCount
                    getCartDisplayCount(userId).then(count => {
                        document.querySelectorAll('.lblCartCount').forEach(el => {
                            el.textContent = count;
                        });
                    }).catch(err => console.error('Error updating cart count:', err));
                } else {
                    toast.error(data.message || 'Failed to add machine test to cart');
                }
            } catch (error) {
                console.error('Error adding machine test to cart:', error);
                toast.error('Unable to add machine test to cart');
            }
        }
        
        // Clear temp data
        this.setState({ tempCartData: null });
    }

    render() {
        const { t } = this.props;
        const { categoryName, categoryId, filteredEvents, loading, filters, pagination, hasMoreEvents, loadingMore, allLoadedEvents, allLoadedMachineTests, displayedEventsCount, displayedTestsCount } = this.state;

        // Check if Machine Tests is selected
        const isMachineTests = filters.events && filters.events[0] === 'Machine Tests';


        // Get the selected event category (first selected event from filters)
        const selectedEventCategory = filters.events && filters.events.length > 0 
            ? filters.events[0] 
            : categoryName || 'Events Information';

        // For the 'All' (View All Topics) page, use translation key for title
        let translatedCategoryName;
        if (!selectedEventCategory || selectedEventCategory === 'All' || selectedEventCategory === 'Events Information') {
            const langKey = this.state.currentLanguage === 'ma' ? 'ma' : 'en';
            const translationData = langKey === 'ma' ? ma : en;
            translatedCategoryName = translationData['booknow_hero_title'] || 'All';
        } else {
            translatedCategoryName = this.getTranslatedCategoryName(selectedEventCategory);
        }

        // Get the event type ID for the selected event (for categoryId)
        const selectedEventTypeId = selectedEventCategory && selectedEventCategory !== 'Events Information'
            ? this.mapEventTypeNameToId(selectedEventCategory)
            : categoryId || '';

        // Get description for selected category (will use API data if available)
        const selectedCategoryDescription = this.getCategoryDescription(selectedEventCategory, selectedEventTypeId);
        
        // Get items to display based on whether machine tests or events are selected
        const eventsToDisplay = allLoadedEvents.length > 0 
            ? allLoadedEvents.slice(0, displayedEventsCount)
            : filteredEvents;
        
        const testsToDisplay = allLoadedMachineTests.slice(0, displayedTestsCount);

        return (
            <div className="event-listing-page">
                <ToastContainer />
                <NewHeader />
                
                {/* Hero Section - Updates based on selected event filter */}
                <EventListingHero 
                    categoryName={translatedCategoryName} 
                    categoryId={selectedEventTypeId}
                    description={selectedCategoryDescription}
                />
                
                <div className="container-fluid event-listing-container">
                    <div className="container-xl">
                        <div className="row">
                            {/* Left Column - Filters */}
                            <div className="col-12 col-md-4 col-lg-3 mb-4">
                                <EventFilters 
                                    onFilterChange={this.handleFilterChange}
                                    initialFilters={filters}
                                    filterOptions={this.state.filterOptions}
                                />
                            </div>
                            
                            {/* Right Column - Event Listing */}
                            <div className="col-12 col-md-8 col-lg-9">
                                {/* Selected Category Info */}
                                <SelectedCategoryInfo 
                                    categoryName={translatedCategoryName}
                                    description={selectedCategoryDescription}
                                />

                                {/* Machine Tests - appointment/contact note below the category description */}
                                {isMachineTests && (
                                    <div className="machine-test-contact my-3 p-3">
                                        <p className="mb-1">{t('home.Please_call_and_take_and_appointment_before_booking_the_Test')}</p>
                                        <p className="mb-1"><strong>{t('home.Contact on')} :</strong> {t('home.Monday_to_Friday')}</p>
                                        <p className="mb-0"><strong>{t('home.Phone')}:</strong> {t('home.Phone_all')}</p>
                                    </div>
                                )}

                                {/* Loading State */}
                                {loading && (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                        <p className="mt-2">Loading {isMachineTests ? 'machine tests' : 'events'}...</p>
                                    </div>
                                )}

                                {/* Event Cards Grid or Machine Test Cards - Conditional Rendering */}
                                {!loading && (
                                    <>
                                        {isMachineTests ? (
                                            /* Machine Tests Layout */
                                            testsToDisplay.length > 0 ? (
                                                <>
                                                    <div className="machine-test-list">
                                                        {testsToDisplay.map((machineTest, index) => (
                                                            <MachineTestCard 
                                                                key={machineTest.event_id || index}
                                                                machineTest={machineTest}
                                                                onAddToCart={this.handleAddToCart}
                                                            />
                                                        ))}
                                                    </div>
                                                    
                                                    {/* Load More for Machine Tests */}
                                                    {allLoadedMachineTests.length > displayedTestsCount && (
                                                        <>
                                                            <div id="load-more-trigger" style={{ height: '20px', marginTop: '20px' }}></div>
                                                            
                                                            <div className="text-center mt-4 mb-4">
                                                                <button
                                                                    className="btn btn-primary"
                                                                    onClick={this.loadMoreEvents}
                                                                    disabled={loadingMore}
                                                                >
                                                                    {loadingMore ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                            Loading...
                                                                        </>
                                                                    ) : (
                                                                        'Load More Machine Tests'
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </>
                                                    )}
                                                    
                                                    {allLoadedMachineTests.length <= displayedTestsCount && allLoadedMachineTests.length > 6 && (
                                                        <div className="text-center py-3">
                                                            <p className="text-muted">All machine tests loaded ({allLoadedMachineTests.length} total)</p>
                                                        </div>
                                                    )}
                                                </>
                                            ) : (
                                                <div className="text-center py-5">
                                                    <p className="text-muted">No machine tests found matching your filters.</p>
                                                </div>
                                            )
                                        ) : (
                                            /* Regular Events Layout */
                                            eventsToDisplay.length > 0 ? (
                                                <>
                                                    <div className="event-cards-grid">
                                                        {eventsToDisplay.map((event, index) => (
                                                            <div key={event.event_id || index} className="event-cards-grid__item">
                                                                <EventCardNew
                                                                    event={event}
                                                                    currentFilters={this.state.filters}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                    
                                                    {/* Lazy Loading Trigger and Load More Button */}
                                                    {/* Show if there are more events to fetch OR more loaded events to display */}
                                                    {(hasMoreEvents || allLoadedEvents.length > displayedEventsCount) && (
                                                        <>
                                                            {/* Invisible trigger for intersection observer */}
                                                            <div id="load-more-trigger" style={{ height: '20px', marginTop: '20px' }}></div>
                                                            
                                                            {/* Load More Button (fallback if intersection observer doesn't work) */}
                                                            <div className="text-center mt-4 mb-4">
                                                                <button
                                                                    className="btn btn-primary"
                                                                    onClick={this.loadMoreEvents}
                                                                    disabled={loadingMore}
                                                                >
                                                                    {loadingMore ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                            Loading...
                                                                        </>
                                                                    ) : (
                                                                        'Load More Events'
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </>
                                                    )}
                                                    
                                                    {/* Show message when all events are loaded AND displayed */}
                                                    {/* {!hasMoreEvents && allLoadedEvents.length <= displayedEventsCount && allLoadedEvents.length > 10 && (
                                                        <div className="text-center py-3">
                                                            <p className="text-muted">All events loaded ({allLoadedEvents.length} total)</p>
                                                        </div>
                                                    )} */}
                                                </>
                                            ) : (
                                                <div className="text-center py-5">
                                                    <p className="text-muted">No events found matching your filters.</p>
                                                </div>
                                            )
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Appointment Alert Modal for Machine Tests */}
                <div className="modal fade z-index--99999" id="MachineTestModal">
                    <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content bg-light-light">
                            <div className="modal-header" style={{ background: '#9d0b0e', height: '15%' }}>
                                <h5 className="modal-title" id="exampleModalLabel" style={{ marginTop: '-5px', color: 'white', fontSize: '15px' }}>
                                    {t('home.APPOINTMENT ALERT')}
                                </h5>
                                <span style={{ color: 'white', cursor: 'pointer', marginTop: '-10px' }} data-dismiss="modal" aria-label="Close">X</span>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        &nbsp;
                                        <img src={getLanguage() === 'ma' ? MachineTests_mr : MachineTests} height={77} className="img-fluid d-xl-none d-lg-none d-md-none d-block" />
                                        <img height="36" width="36" className="img-fluid d-xl-inline d-lg-inline d-md-inline d-none" src={thumbImage} />
                                        &nbsp; {t('home.thank you for choosing Machine Tests')}
                                        <br />
                                        <p style={{ marginTop: '13px' }}>
                                            {t('home.research_center')}
                                            <br />
                                            {t('home.avoid inconvenience to you')}
                                        </p>
                                        <p>
                                            {t('home.If you have taken the appointment please')}
                                        </p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-12 col-lg-12 col-md-12 d-xl-flex d-lg-flex d-md-flex d-none">
                                        <button type="button" className="btn btn-brown btn-sm mb-2" onClick={this.addToCartContinue}>
                                            {t('home.CONTINUE Machine Test')}
                                        </button>
                                    </div>
                                    <div className="col-xl-12 col-lg-12 col-md-12 d-xl-flex d-lg-flex d-md-flex d-none">
                                        {t('home.call_on_machine')}
                                    </div>
                                    <div className="col-xl-12 col-lg-12 col-md-12 d-xl-flex d-lg-flex d-md-flex d-none">
                                        <button style={{ color: 'white', cursor: 'pointer' }} className="btn btn-brown btn-sm mb-2" data-dismiss="modal" aria-label="Close">
                                            {t('home.CLOSE Machine Test')}
                                        </button>
                                    </div>

                                    <div className="col-sm-12 col-xs-12 d-xl-none d-lg-none d-md-none d-flex">
                                        <button type="button" className="btn btn-brown btn-sm mb-2 btn-block" onClick={this.addToCartContinue}>
                                            {t('home.CONTINUE Machine Test')}
                                        </button>
                                    </div>
                                    <div className="col-sm-12 col-xs-12 d-xl-none d-lg-none d-md-none d-flex">
                                        {t('home.call_on_machine')}
                                    </div>
                                    <div className="col-sm-12 col-xs-12 d-xl-none d-lg-none d-md-none d-flex">
                                        <button className="btn btn-outline-brown btn-sm mb-2 btn-block" data-dismiss="modal" aria-label="Close">
                                            {t('home.CLOSE Machine Test')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default withRouter(translate(EventListingPage));


